const SmoothScroll = (function($) {
  const _s = {
    links: 'a[href^="#"]'
  };

  const _init = function() {
    _bindEvents();
  };

  const _bindEvents = function() {
    $(document).on('click', _s.links, _handleClick);
  };

  const _handleClick = function(e) {
    const $link = $(this);
    const href = $link.attr('href');
    
    if (href === '#' || href === '#top') {
      e.preventDefault();
      _scrollToTop();
      return;
    }

    const targetId = href.substring(1);
    const $target = $('#' + targetId);

    if ($target.length) {
      e.preventDefault();
      _scrollToElement($target);
      
      if (history.pushState) {
        history.pushState(null, null, href);
      }
    }
  };

  const _scrollToTop = function() {
    $('html, body').animate({
      scrollTop: 0
    }, 800, 'swing');
  };

  const _scrollToElement = function($element) {
    const offset = $element.offset().top;
    const headerHeight = _getHeaderHeight();
    const scrollPosition = offset - headerHeight - 20;

    $('html, body').animate({
      scrollTop: scrollPosition
    }, 800, 'swing');
  };

  const _getHeaderHeight = function() {
    const $header = $('header, .site-header, .header');
    return $header.length ? $header.outerHeight() : 0;
  };

  return {
    init: _init
  };
})(jQuery);

export default SmoothScroll;